module.exports = __webpack_public_path__ + "img/lotus-logo.8e6e98ea.svg";